<div class="dashboard_content_wrapper">
    <div class="questions_content p-3">
        <div class="title_progress text-center mt-4 mb-5">
            <h2 class="h2">Who is this message for?</h2>
            <p class="tagline">
                Indicate the intended recipients of your message
            </p>
        </div>
        <div class="message_for_wrapper">
            <div class="message_for_content d-flex justify-content-center" style="gap: 20px;">
                <a (click)="selectType(true,'family')">
                    <div class="single_messager" 
                    style="border-radius: 8px;
                    border: 1px solid rgba(0, 9, 57, 0.10);
                    background: #FFF;
                    text-align: center;
                    padding: 30px 40px;">
                        <img src="assets/images/family-icon.svg" alt="familyicon" />
                        <p class="title" style="
                        font-weight: 600 !important;
                        margin: 20px 0 10px !important;
                        font-size: 18px !important;
                        min-height: 81px;

                        ">My Family</p>
                        <p class="tagline" 
                        style="font-size: 14px;
                        margin: 0 !important;">
                            Indicate the intended recipients of your message
                        </p>
                    </div>
                </a>
                <a (click)="selectType()">
                    <div class="single_messager "
                    style="border-radius: 8px;
                    border: 1px solid rgba(0, 9, 57, 0.10);
                    background: #FFF;
                    text-align: center;
                    padding: 30px 40px;"
                    >
                        <img src="assets/images/individual-icon.svg" alt="familyicon" />
                        <p class="title"
                        style="
                        font-weight: 600 !important;
                        margin: 20px 0 10px !important;
                        font-size: 18px !important;
                        min-height: 81px;

                        ">Other individuals</p>
                        <p class="tagline"
                        style="font-size: 14px;
                        margin: 0 !important;">
                            Indicate the intended recipients of your message
                        </p>
                    </div>
                </a>
                <a (click)="selectType(true,'TPA')">
                    <div class="single_messager"
                    style="border-radius: 8px;
                    border: 1px solid rgba(0, 9, 57, 0.10);
                    background: #FFF;
                    text-align: center;
                    padding: 30px 40px;">
                        <img src="assets/images/family-icon.svg" alt="familyicon" />
                        <p class="title"
                        style="
                        font-weight: 600 !important;
                        margin: 20px 0 10px !important;
                        font-size: 18px !important;
                        min-height: 81px;

                        ">Trusted Professional Advisors</p>
                        <p class="tagline"
                        style="font-size: 14px;
                        margin: 0 !important;">
                            Indicate the intended recipients of your message
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>